import {
  ChangeDetectionStrategy,
  Component,
  input,
  inject,
} from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable, switchMap } from 'rxjs';
import {
  AssetImage,
  ExternalLinkComponent,
  Icon,
  IconComponent,
  ImageThumbnailComponent,
  SlimButtonComponent,
  SpinnerFilledComponent,
} from '@web/shared/ui';
import {
  Route,
  RouteParam,
  RouterLinkComponent,
  RouterLinkParams,
} from '@web/common';
import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionPanel,
} from 'primeng/accordion';
import { PublicCosmeticImagesGalleriaComponent } from '../public-cosmetic-images-galleria/public-cosmetic-images-galleria.component';
import { PublicCosmeticDataSourceService } from '../../services/public-cosmetic-data-source.service';
import { PublicCosmeticDetails } from '../../models/public-cosmetic-details';
import { SummernoteHtmlPreviewComponent } from '@web/shared/external';
import { isNotNil, valueOrDefault } from '@web/utils';
import { PublicCosmeticBox } from '../../models/public-cosmetic-box';

@Component({
  selector: 'app-public-cosmetic-details',
  imports: [
    Accordion,
    AccordionContent,
    AccordionHeader,
    AccordionPanel,
    CommonModule,
    ExternalLinkComponent,
    ImageThumbnailComponent,
    NgOptimizedImage,
    PublicCosmeticImagesGalleriaComponent,
    RouterLinkComponent,
    SlimButtonComponent,
    SpinnerFilledComponent,
    SummernoteHtmlPreviewComponent,
    IconComponent,
  ],
  templateUrl: './public-cosmetic-details.component.html',
  styleUrl: './public-cosmetic-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicCosmeticDetailsComponent {
  /* prettier-ignore */
  private readonly publicCosmeticDataSource = inject(PublicCosmeticDataSourceService);

  public readonly slug = input.required<string>();

  protected readonly slug$ = toObservable(this.slug);
  protected readonly cosmetic$ = this.cosmeticSource();
  protected readonly AssetImage = AssetImage;
  protected readonly Route = Route;
  protected readonly RouteParam = RouteParam;
  protected readonly Icon = Icon;
  protected readonly isNotNil = isNotNil;
  protected readonly valueOrDefault = valueOrDefault;

  protected cosmeticDetailsParams(slug: string): RouterLinkParams {
    return {
      [RouteParam.Slug]: slug,
    };
  }

  protected prepareBoxDetailsParams(box: PublicCosmeticBox): RouterLinkParams {
    return {
      [RouteParam.Slug]: box.slug,
    };
  }

  private cosmeticSource(): Observable<PublicCosmeticDetails> {
    return this.slug$.pipe(
      switchMap((slug) =>
        this.publicCosmeticDataSource.fetchDetailsBySlug(slug),
      ),
    );
  }
}
